import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  paper: {
    fontFamily: `'Manrope', sans-serif`,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    width: "60vw",
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: "1.5rem",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
    position: "relative",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("xl")]: {
      overflowY: "scroll",
      overflowX: "hidden",
    },
    [theme.breakpoints.down("lg")]: {
      height: "70vh",
      overflowY: "scroll",
      overflowX: "hidden",
      paddingRight: ".55rem",
    },
    "& button": {
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "1.5rem",
    paddingBottom: 0,
  },
  modalHeaderTitle: {
    marginBottom: 8,
    fontSize: 20,
    lineHeight: "28px",
    color: "#344054",
    fontWeight: "bold",
  },
  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal",
  },
  modalSection: {
    padding: "1.5rem",
    paddingTop: 0,
  },
  modalFooter: {
    background: "#F7F7F9",
    height: 80,
    borderRadius: "0 0 8px 8px",
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  modalFooterCancel: {
    background: "transparent",
    color: "#F97066",
    borderRadius: 8,
    boxShadow: "none",
    marginRight: 8,
    "&:hover": {
      background: "transparent",
      color: "#F97066",
    },
  },
  modalFooterAssign: {
    background: "#32D583",
    color: "#fff",
    borderRadius: 8,
    boxShadow: "none",
    "&:hover": {
      background: "#32D583",
      color: "#fff",
    },
  },
  modalBodyTitle: {
    color: "#465869",
    fontSize: 18,
    lineHeight: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  loadingComponent: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#4658691c",
    zIndex: 99,
    width: "100%",
    height: "100%",
  },
  checkboxFormLabelControl: {
    display: "flex",
    margin: 0,
    "& span:first-child": {
      padding: "2px 2px 0 1px",
    },
    "& span:nth-child(2)": {
      color: "#465869",
      fontSize: 14,
      fontWeight: "normal",
      fontFamily: `'Manrope', sans-serif`,
      marginTop: 4,
    },
  },
  permissionsList: {
    maxHeight: 350,
    overflowY: "auto",
    overflowX: "hidden",
  },
  accordion: {
    border: "none",
    boxShadow: "none",
  },
  accordionSummary: {
    backgroundColor: "#EDF5FB",
    borderRadius: 8,
    color: "#465869",
    maxHeight: 48,
    minHeight: "48px !important",
    height: "48px !important",
  },
  accordionDetailsGrid: {
    margin: "0 0 0 -4px",
  },
  accordionDetailsTitle: {
    color: "#465869",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "19px",
  },
  accordionDetailsLabel: {
    wordWrap: "break-word",
    marginBottom: 0,
  },
  skeleton: {
    transform: "none",
    width: "100%",
    height: 52,
  },
}));

export default styles;
